import React from 'react'

import { ResizeContext } from 'contexts/Resize'

import WAboutCompareDetailsDesktop from './components/WAboutCompareDetailsDesktop'
import WAboutCompareDetailsMobile from './components/WAboutCompareDetailsMobile'

const WAboutCompareDetails = props => {
  const { mobile, tablet, breakpoint } = React.useContext(ResizeContext)

  if (mobile || tablet || breakpoint === '') {
    return <WAboutCompareDetailsMobile isTablet={tablet} {...props} />
  }

  return <WAboutCompareDetailsDesktop {...props} />
}

export default WAboutCompareDetails
